/**
 * Parse `filename` / `filename*` from a Content-Disposition header (RFC 2616 / RFC 5987).
 */
export function parseContentDispositionFilename(
  header: string | null | undefined,
): string | undefined {
  if (!header?.trim()) return undefined;
  const h = header.trim();
  const star = /filename\*\s*=\s*([^']*)''([^;\s]+)/i.exec(h);
  if (star?.[2]) {
    try {
      return decodeURIComponent(star[2].replace(/["']/g, "").trim());
    } catch {
      /* fall through */
    }
  }
  const quoted = /filename\s*=\s*"((?:\\.|[^"\\])*)"/i.exec(h);
  if (quoted?.[1]) {
    return quoted[1].replace(/\\(.)/g, "$1").trim();
  }
  const plain = /filename\s*=\s*([^;\s]+)/i.exec(h);
  if (plain?.[1]) {
    return plain[1].replace(/^["']|["']$/g, "").trim();
  }
  return undefined;
}

/** Strip path segments for safe `download=` attribute values */
export function sanitizeDownloadBasename(
  name: string | undefined,
): string | undefined {
  if (!name?.trim()) return undefined;
  const base = name
    .replace(/^.*[/\\]/, "")
    .replace(/[/\\?%*:|"<>]/g, "-")
    .trim();
  if (!base) return undefined;
  return base.slice(0, 200);
}
